/**
 * contentupdatesactions.js
 * Created by calhosh on 12/16/2020.
 */

import Env from '../../../src/util/env';
import * as types from '../actiontypes';
import { serviceURL } from '../../../src/util/uiconstants';

export const getContentUpdates = (url) => {
	return {
		type: types.GET_CONTENT_UPDATES,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const importContent = (engagementId, data) => {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}Contents`;
	return {
		type: types.IMPORT_CONTENT,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		}
	};
};
